import { render, staticRenderFns } from "./ClassroomMonitoring.vue?vue&type=template&id=34b10b48&scoped=true"
import script from "./ClassroomMonitoring.vue?vue&type=script&lang=js"
export * from "./ClassroomMonitoring.vue?vue&type=script&lang=js"
import style0 from "./ClassroomMonitoring.vue?vue&type=style&index=0&id=34b10b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b10b48",
  null
  
)

export default component.exports